<template>
  <div class="banner-promotion-container">
    <div class="banner-promotion-content">
      <img
        src="/img/banner/promotion-mobile.jpg"
        alt="Banner com a descrição: Muita internet e apps ilimitados, o plano 100% digital e sem fidelidade."
        class="image-banner-mobile"
        v-if="sizeScreen < 768"
      />
      <img
        src="/img/banner/promotion.jpg"
        alt="Banner com a descrição: Muita internet e apps ilimitados, o plano 100% digital e sem fidelidade."
        class="image-banner-tablet"
        v-if="sizeScreen >= 768 && sizeScreen < 1025"
      />
      <img
        src="/img/banner/promotion.jpg"
        alt="Banner com a descrição: Muita internet e apps ilimitados, o plano 100% digital e sem fidelidade."
        class="image-banner"
        v-if="sizeScreen >= 1025"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { pushTagEvent } from "@/helpers/Gtm/gaExecuteEvents";
import { EVENT_NAME } from "@/helpers/Gtm/events";

@Component({
  name: "MotherBanner",
  components: {},
})
export default class MotherBanner extends Vue {
  ga4Event(type: string) {
    let eventName = EVENT_NAME.BTN_BAIXA_APP_CLARO_FLEX_ANDROID;

    if (type === "ios") {
      eventName = EVENT_NAME.BTN_BAIXA_APP_CLARO_FLEX_IOS;
    }

    pushTagEvent({ eventName });
  }

  get sizeScreen() {
    return window.screen.width;
  }
}
</script>

<style lang="scss" scoped>
.banner-promotion-container {
  width: calc(100% + 2rem);
  height: auto;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -1rem;
  border-bottom: 1px solid #dbdbdb;

  .banner-promotion-content {
    width: 100%;
    height: auto;
    position: relative;
    margin-top: -1px;

    .image-banner {
      display: none;
    }

    .image-banner-tablet {
      display: none;
    }

    .image-banner-mobile {
      width: 100%;
      height: auto;
      padding: 2rem;
    }

    .buttons-banner-container {
      width: 100%;
      height: 42px;
      display: flex;
      justify-content: center;
      position: absolute;
      gap: 15px;
      bottom: 4.4%;

      h3 {
        display: none;
      }

      a {
        img {
          width: 110px;
          height: 36px;

          @media (min-width: 360px) {
            width: 146px;
            height: 42px;
          }

          @media (min-width: 411px) {
            width: 153px;
            height: 44px;
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    .banner-promotion-content {
      .image-banner {
        display: none;
      }

      .image-banner-tablet {
        width: 100%;
        height: auto;
        display: block;
        padding: 2rem;
      }

      .image-banner-mobile {
        display: none;
      }

      .buttons-banner-container {
        width: 100%;
        height: 92px;
        justify-content: left;
        flex-wrap: wrap;
        bottom: 21%;
        margin-left: 4%;

        h3 {
          width: 100%;
          height: 28px;
          display: block;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          font-family: "Roboto", sans-serif;
          line-height: 28px;

          text-transform: uppercase;

          color: #ffffff;
        }

        a {
          height: 44px;

          img {
            width: 116px;
            height: 33px;
          }
        }
      }
    }
  }

  @media (min-width: 1025px) {
    margin: -1px -1rem;
    background-color: #ffffff;
    justify-content: left;
    margin: -1px -1rem;

    .banner-promotion-content {
      width: 1161px;
      height: auto;
      margin: 0 auto;
      position: relative;

      .image-banner-tablet {
        display: none;
      }

      .image-banner-mobile {
        display: none;
      }

      .image-banner {
        display: block;
        margin: 0 auto;
        padding: 2rem 0;
      }

      .buttons-banner-container {
        width: 100%;
        height: 98px;
        display: flex;
        justify-content: left;
        position: absolute;
        gap: 15px;
        margin-left: 64px;
        bottom: 80px;

        h3 {
          font-family: "Roboto", sans-serif;
          font-size: 18px;
        }

        a {
          img {
            width: 155px;
            height: 44px;
          }
        }
      }
    }
  }
}
</style>
